(function(){
  function placeCurriculumFeature(){
    var feature=document.querySelector('[data-kcf]');
    if(!feature) return;
    var root=document.querySelector('.kmi[data-kmi-view]');
    if(!root) return;
    var placement=feature.getAttribute('data-kcf-placement');
    var hero=root.querySelector('.kmi-hero');
    if(!hero) return;
    if(placement==='library'){
      hero.insertAdjacentElement('afterend',feature);
    }else{
      var stage=hero.nextElementSibling;
      if(stage) stage.insertAdjacentElement('afterend',feature);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',placeCurriculumFeature,{once:true}); else placeCurriculumFeature();
  document.addEventListener('shopify:section:load',placeCurriculumFeature);
})();